import { popup } from '../../../../addons/Popup';
import { getAsync } from '../../../../utils/api';

export default async (formId: string) => {
  const { cancelled } = await popup({
    message: "Form Arşivlensin mi?",
    buttonText: "Arşivle",
  });
  if (cancelled) return;

  const res = await getAsync("/forms/set-archived?archived=true&id=" + formId);
  if (!res.success) return;

  popup("Arşivlendi");
};
